/**
 * RedRock Monitoring Admin BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SearchEquipmentModelsDictionaryResponse } from './search-equipment-models-dictionary-response';


export interface SearchEquipmentModelsDictionaryResponsePagedList { 
    totalCount?: number;
    items?: Array<SearchEquipmentModelsDictionaryResponse> | null;
}

